import React from "react"
import { Link } from "gatsby"
import Button from "./pseudoButton"

import styles from "./postItem.module.scss"

const PostItem = ({ post, postType, colorPalette }) => {
  let buttonLabel = ``
  if (postType === "blog") {
    buttonLabel = `Read the Blog`
  } else {
    buttonLabel = `Read More`
  }

  return (
    <article
      key={post.id}
      className={styles.postItem}
      data-theme={
        postType === "case-studies"
          ? ""
          : colorPalette?.color
          ? colorPalette.color
          : "categoryYellow"
      }
    >
      <Link
        to={
          post.category && postType !== "case-studies"
            ? `/${postType}/${post.category.slug.current}/${post.slug.current}/`
            : `/${postType}/${post.slug.current}/`
        }
      >
        {post._rawThumbnail && (
          <div
            className={styles.postThumb}
            style={{ backgroundImage: `url(${post._rawThumbnail.asset.url})` }}
          ></div>
        )}
        <div className={styles.postItemInner}>
          <header>
            {post.category && (
              <p className={styles.postCat}>{post.category.title}</p>
            )}
            {post.startDate && (
              <p className={styles.postCat}>{`${post.startDate}${
                post.endDate ? " - " + post.endDate : ""
              }`}</p>
            )}
            <h2>{post.title}</h2>
          </header>
          <p className={styles.postExcerpt}>{post.excerpt}</p>
          <footer className={styles.postButton}>
            <Button label={buttonLabel} />
          </footer>
        </div>
      </Link>
    </article>
  )
}

export default PostItem
